const msalConfig = {
  auth: {
    clientId: "c3fd4b35-fd6b-4900-8981-f7eb24dd6e90",
    authority: "https://login.microsoftonline.com/9be81a95-7870-42f4-bb8d-a44ada88130a",
    redirectUri: "https://eryl-acs.generax.ai/layout/chat",
    postLogoutRedirectUri: "http://eryl-acs.generax.ai/login",
  },
};

export default msalConfig;